import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Helpers from "../../utils/helpers";
 
const OrderReviewItems = (props: any) => {
 
  const products = props.orderedItems?.props?.orderinfo?.products || [];
  const imageBodyTemplate = (rowData: any) => {
    return (
      <img
        src={
          rowData.productImageURL ||
          process.env.PUBLIC_URL + "/assests/images/Desiri-Groundnut-Oils.png"
        }
        alt={rowData.productName}
        width="30%"
      />
    );
  };
 
  const unitPriceBodyTemplate = (rowData: any) => {
    return Helpers.formatAmountInINR(rowData.unitPrice);
  };
 
  const taxableAmountBodyTemplate = (rowData: any) => {
    return Helpers.formatAmountInINR(rowData.amount);
  };
 
  const taxAmountBodyTemplate = (rowData: any) => {
    return Helpers.formatAmountInINR(rowData.tax);
  };
 
  const grossAmountBodyTemplate = (rowData: any) => {
    return Helpers.formatAmountInINR(Math.round(rowData.amount+rowData.tax));
  };
 
  return (
    <>
      <DataTable
        value={products}  // Use the products array directly
        tableStyle={{ minWidth: "50rem" }}
        size="small"
      >
        <Column
          field="productName"
          style={{ width: "30%" }}
          header="Name"
        ></Column>
        <Column
          header="Image"
          style={{ width: "15%" }}
          body={imageBodyTemplate}
        ></Column>
        <Column
          field="unitPrice"
          header="Price"
          body={unitPriceBodyTemplate}
          bodyStyle={{ textAlign: "right" }}
        ></Column>
        <Column
          field="quantity"
          header="Quantity"
          bodyStyle={{ textAlign: "right" }}
        ></Column>
        <Column
          field="taxableAmount"
          header="Amount"
          body={taxableAmountBodyTemplate}
          bodyStyle={{ textAlign: "right" }}
        ></Column>
        <Column
          field="taxAmount"
          header="Tax"
          body={taxAmountBodyTemplate}
          bodyStyle={{ textAlign: "right" }}
        ></Column>
        <Column
          field="totalAmount"
          header="Total Amount"
          body={grossAmountBodyTemplate}
          bodyStyle={{ textAlign: "right" }}
        ></Column>
      </DataTable>
    </>
  );
};
 
export default OrderReviewItems;
 